import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import SkillCard from "./components/SkillCard";
import LearningJourney from "./components/LearningJourney";
import TechStackRecommender from "./components/TechStackRecommender";
import CertificationShowcase from "./components/CertificationShowcase";
import SkillRelationshipMap from "./components/SkillRelationshipMap";

const SkillsLaboratory = () => {
  const [activeSkill, setActiveSkill] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const skills = [
    {
      id: 1,
      name: "React",
      category: "Frontend",
      proficiency: "Intermediate",
      experience: "1+ years",
      percentage: 85,
      icon: "Layers",
      recentProjects: [
        "E-commerce Platform",
        // "Dashboard Analytics",
        // "Social Media App",
        "Logistics Management System",
        "Portfolio Website",
      ],
      relatedTech: [
        "TypeScript",
        "Next.js",
        "Tailwind CSS",
        "React Query",
        // "Framer Motion",
      ],
    },
    {
      id: 2,
      name: "Node.js",
      category: "Backend",
      proficiency: "Intermediate",
      experience: "1+ years",
      percentage: 70,
      icon: "Server",
      recentProjects: [
        "REST API Service",
        // "Real-time Chat",
        // "Microservices Architecture",
      ],
      relatedTech: [
        "Express.js",
        "MongoDB",
        //  "PostgreSQL", "Socket.io",
        "JWT",
      ],
    },
    {
      id: 3,
      name: "TypeScript",
      category: "Language",
      proficiency: "Intermediate",
      experience: "1+ years",
      percentage: 70,
      icon: "Code2",
      recentProjects: [
        // "Enterprise Dashboard",
        // "API Gateway",
        // "Component Library",
      ],
      relatedTech: [
        "React",
        "Node.js",
        //  "GraphQL", "Jest",
        "ESLint",
      ],
    },
    // {
    //   id: 4,
    //   name: "Python",
    //   category: "Language",
    //   proficiency: "Advanced",
    //   experience: "4+ years",
    //   percentage: 88,
    //   icon: "FileCode",
    //   recentProjects: [
    //     "ML Pipeline",
    //     "Data Analysis Tool",
    //     "Web Scraper",
    //     "API Backend",
    //   ],
    //   relatedTech: ["Django", "FastAPI", "Pandas", "NumPy", "TensorFlow"],
    // },
    // {
    //   id: 5,
    //   name: "AWS",
    //   category: "Cloud",
    //   proficiency: "Advanced",
    //   experience: "3+ years",
    //   percentage: 82,
    //   icon: "Cloud",
    //   recentProjects: [
    //     "Serverless Architecture",
    //     "Container Deployment",
    //     "CI/CD Pipeline",
    //   ],
    //   relatedTech: ["EC2", "S3", "Lambda", "RDS", "CloudFormation"],
    // },
    {
      id: 6,
      name: "MongoDB",
      category: "Database",
      proficiency: "Intermediate",
      experience: "1+ years",
      percentage: 60,
      icon: "Database",
      recentProjects: [
        "User Management System",
        // "Content Management",
        // "Analytics Platform",
      ],
      relatedTech: [
        "Mongoose",
        "Aggregation",
        // "Atlas","GridFS",
        // "Compass"
      ],
    },
    // {
    //   id: 7,
    //   name: "Docker",
    //   category: "DevOps",
    //   proficiency: "Intermediate",
    //   experience: "2+ years",
    //   percentage: 75,
    //   icon: "Package",
    //   recentProjects: [
    //     "Containerized Apps",
    //     "Development Environment",
    //     "CI/CD Integration",
    //   ],
    //   relatedTech: [
    //     "Kubernetes",
    //     "Docker Compose",
    //     "Registry",
    //     "Swarm",
    //     "Buildx",
    //   ],
    // },
    // {
    //   id: 8,
    //   name: "GraphQL",
    //   category: "API",
    //   proficiency: "Intermediate",
    //   experience: "2+ years",
    //   percentage: 70,
    //   icon: "Network",
    //   recentProjects: [
    //     "API Gateway",
    //     "Real-time Subscriptions",
    //     "Mobile Backend",
    //   ],
    //   relatedTech: [
    //     "Apollo",
    //     "Relay",
    //     "Prisma",
    //     "TypeGraphQL",
    //     "Subscriptions",
    //   ],
    // },
    // {
    //   id: 9,
    //   name: "Machine Learning",
    //   category: "AI/ML",
    //   proficiency: "Learning",
    //   experience: "1+ year",
    //   percentage: 60,
    //   icon: "Brain",
    //   recentProjects: [
    //     "Image Classification",
    //     "Sentiment Analysis",
    //     "Recommendation System",
    //   ],
    //   relatedTech: [
    //     "TensorFlow",
    //     "PyTorch",
    //     "Scikit-learn",
    //     "Jupyter",
    //     "OpenCV",
    //   ],
    // },
  ];

  const categories = [
    { id: "all", name: "All Skills", icon: "Grid3x3" },
    { id: "Frontend", name: "Frontend", icon: "Layers" },
    { id: "Backend", name: "Backend", icon: "Server" },
    { id: "Language", name: "Languages", icon: "Code2" },
    { id: "Database", name: "Database", icon: "Database" },
    // { id: "Cloud", name: "Cloud", icon: "Cloud" },
    // { id: "DevOps", name: "DevOps", icon: "Package" },
    // { id: "API", name: "API", icon: "Network" },
    // { id: "AI/ML", name: "AI/ML", icon: "Brain" },
  ];

  const filteredSkills = skills?.filter((skill) => {
    const matchesCategory =
      selectedCategory === "all" || skill?.category === selectedCategory;
    const matchesSearch =
      skill?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      skill?.category?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      skill?.relatedTech?.some((tech) =>
        tech?.toLowerCase()?.includes(searchTerm?.toLowerCase())
      );
    return matchesCategory && matchesSearch;
  });

  const handleSkillHover = (skill) => {
    setActiveSkill(skill);
  };

  useEffect(() => {
    // Set default active skill
    if (!activeSkill && skills?.length > 0) {
      setActiveSkill(skills?.[0]);
    }
  }, [activeSkill]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Hero Section */}
      <section className="pt-24 pb-16 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-3 mb-6">
              {/* <div className="w-16 h-16 bg-gradient-to-br from-conversion-accent to-trust-builder rounded-xl hidden sm:flex items-center justify-center">
                <Icon name="Zap" size={32} className="text-white" />
              </div> */}
              <div>
                <h1 className="text-4xl lg:text-5xl font-bold text-foreground">
                  Skills <br />
                  <span className="text-conversion-accent">Laboratory</span>
                </h1>
                <p className="text-xl text-muted-foreground mt-2">
                  Interactive exploration of technical competencies
                </p>
              </div>
            </div>

            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Dive deep into my technical expertise through dynamic skill
              assessments, technology relationships, and strategic
              recommendations. Discover how different technologies work together
              in real-world projects.
            </p>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            <div className="text-center p-6 bg-card border border-border rounded-xl">
              <div className="text-3xl font-bold text-conversion-accent mb-2">
                {skills?.length}
              </div>
              <div className="text-sm text-muted-foreground">
                Technical Skills
              </div>
            </div>
            <div className="text-center p-6 bg-card border border-border rounded-xl">
              <div className="text-3xl font-bold text-trust-builder mb-2">
                {skills?.filter((s) => s?.proficiency === "Expert")?.length}
              </div>
              <div className="text-sm text-muted-foreground">Expert Level</div>
            </div>
            <div className="text-center p-6 bg-card border border-border rounded-xl">
              <div className="text-3xl font-bold text-warning mb-2">1+</div>
              <div className="text-sm text-muted-foreground">
                Years Experience
              </div>
            </div>
            <div className="text-center p-6 bg-card border border-border rounded-xl">
              <div className="text-3xl font-bold text-success mb-2">4+</div>
              <div className="text-sm text-muted-foreground">
                Projects Completed
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Skills Explorer */}
      <section className="py-16 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
            <h2 className="text-3xl font-bold text-foreground">
              Skills Explorer
            </h2>

            {/* Search and Filter */}
            <div className="w-full md:w-auto flex items-center">
              <div className="relative w-full md:w-80">
                <Icon
                  name="Search"
                  size={20}
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
                />
                <input
                  type="text"
                  placeholder="Search skills..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                  className="w-full pl-10 pr-4 py-2 bg-card border border-border rounded-lg text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-conversion-accent/50"
                />
              </div>
            </div>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap gap-2 mb-8">
            {categories?.map((category) => (
              <button
                key={category?.id}
                onClick={() => setSelectedCategory(category?.id)}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-smooth ${
                  selectedCategory === category?.id
                    ? "bg-conversion-accent text-white"
                    : "bg-card border border-border text-muted-foreground hover:text-foreground hover:border-conversion-accent/30"
                }`}
              >
                <Icon name={category?.icon} size={16} />
                <span>{category?.name}</span>
              </button>
            ))}
          </div>

          {/* Skills Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredSkills?.map((skill) => (
              <SkillCard
                key={skill?.id}
                skill={skill}
                onHover={handleSkillHover}
                isActive={activeSkill?.id === skill?.id}
              />
            ))}
          </div>

          {/* No Results */}
          {filteredSkills?.length === 0 && (
            <div className="text-center py-12">
              <Icon
                name="Search"
                size={48}
                className="text-muted-foreground mx-auto mb-4"
              />
              <h3 className="text-xl font-semibold text-foreground mb-2">
                No skills found
              </h3>
              <p className="text-muted-foreground">
                Try adjusting your search terms or category filter
              </p>
            </div>
          )}
        </div>
      </section>
      {/* Technology Relationships */}
      <section className="py-16 px-6 lg:px-8 bg-muted/5">
        <div className="max-w-7xl mx-auto">
          <SkillRelationshipMap activeSkill={activeSkill} />
        </div>
      </section>
      {/* Learning Journey */}
      {/* <section className="py-16 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <LearningJourney />
        </div>
      </section> */}
      {/* Tech Stack Recommender */}
      {/* <section className="py-16 px-6 lg:px-8 bg-muted/5">
        <div className="max-w-7xl mx-auto">
          <TechStackRecommender />
        </div>
      </section> */}
      {/* Certifications */}
      {/* <section className="py-16 px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <CertificationShowcase />
        </div>
      </section> */}
      {/* Call to Action */}
      <section className="py-16 px-6 lg:px-8 bg-gradient-to-r from-conversion-accent/10 to-trust-builder/10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Ready to Build Something Amazing?
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            Let's discuss how my technical expertise can help bring your project
            to life. I'm always excited to tackle new challenges and learn
            emerging technologies.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/contact">
              <button className="flex items-center space-x-2 px-8 py-4 bg-conversion-accent hover:bg-conversion-accent/90 text-white font-semibold rounded-lg transition-smooth">
                <Icon name="MessageCircle" size={20} />
                <span>Start a Conversation</span>
              </button>
            </Link>

            <button className="flex items-center space-x-2 px-8 py-4 bg-card border border-border hover:border-conversion-accent/50 text-foreground font-semibold rounded-lg transition-smooth">
              <Icon name="Download" size={20} />
              <span>Download Resume</span>
            </button>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 px-6 lg:px-8 border-t border-border">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-muted-foreground">
            © {new Date()?.getFullYear()} Yash Pal. Crafted with ❤️ and passion.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SkillsLaboratory;
